import { Component, Input, OnInit, Type } from '@angular/core';
import * as XLSX from 'xlsx';
import { isEmptyArray, isHazardMeasureSaveFailed, isNotEmptyArray ,getMeasureTypeTranslationKey} from 'src/app/utilities/utils';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BackendCallService } from 'src/app/services/backend-call/backend-call.service';
import { LoadingController, ModalController, ToastController } from '@ionic/angular';
import { ShareValuesService } from 'src/app/services/sharedValues/share-values.service';
import { UserAuthService } from 'src/app/services/user-auth/user-auth.service';
import { LocalSettingsService } from 'src/app/services/local-settings/local-settings.service';
import { GraphService } from '../../services/graph/graph.service';
import { Workbook } from 'exceljs';
import * as fs from 'file-saver';
import { AppConstants, HazardMeasureConstants, ObservationEvents, appLanguageOptions, controlMeasures, initialHazards, legislationsDocuments, machineLibrary, quoteTemplateLibrary, riskAssessmentReport, roadmapLibrary, standardsDocuments } from 'src/app/utilities/constant';
import { ToastService } from 'src/app/services/toast.service';
import { EventProvider } from 'src/app/services/event';
import { SubSink } from 'subsink';
type AOA = any[][];

@Component({
  selector: 'app-upload-machine-doc',
  templateUrl: './upload-machine-doc.component.html',
  styleUrls: ['./upload-machine-doc.component.scss'],
})
export class UploadMachineDocComponent implements OnInit {
  public HazardMeasureConstants = HazardMeasureConstants;
  data: AOA = [[1, 2], [3, 4]];
  master = [];
  roadMapData = [];
  @Input() type: any;
  isShowButton: any;
  isButtonEnable = false;
  libraryManagementUserInfo = [];
  roadMapUploadData: any;
  configure: any;
  UserId: any;
  uploadFileName: any;
  uploadFileList: any = [];
  savedLibraryList: any;
  header: any;
  applicationlist: any;
  applications: any;
  machineTypelist: any;
  machineTypes: any;
  featurelist: any;
  features: any;
  controlSystemlist: any;
  controlSystems: any;
  machinemodelist: any;
  machineModes: any;
  bulkMachinePayload = [];
  measureTypeList: any;
  public subs = new SubSink();

  constructor(
    public backendService: BackendCallService,
    public modalController: ModalController,
    public toastController: ToastController,
    public sharedValue: ShareValuesService,
    public router: Router,
    public authService: UserAuthService,
    public localSettingsSrv: LocalSettingsService,
    private graphService: GraphService,
    public loadingController: LoadingController,
    private toastService: ToastService,
    private translate: TranslateService,
    public eventProvider: EventProvider
  ) { }

  ngOnInit() {
    this.subs.unsubscribe();
    this.getUserList();
    this.getMachineReferencesForBulkUpload();
    this.sharedValue.getControlMeasureType();
    this.applicationlist = this.applications = [];
    this.machineTypelist = this.machineTypes = [];
    this.featurelist = this.features = [];
    this.machinemodelist = this.machineModes = [];
    this.controlSystemlist = this.controlSystems = [];

  }

/**
 * Gets machine references for bulk upload
 */
  private getMachineReferencesForBulkUpload(isDownload?) {
    this.machinemodelist = this.sharedValue.machineModeList.map(ele => ele?.name);
    this.backendService.getMachineReferencesForBulkUpload().subscribe((data: any) => {
      const response = data.value;
      this.applications = response.application;
      this.machineTypes = response.machineType;
      this.features = response.specificFeature;
      this.controlSystems = response.controlSystem;
      this.machineModes = this.sharedValue.machineModeList;
      // Following lists are used to show the machine attributes data in the dropdown, that can select via excel sheet
      this.applicationlist = response.application.map(ele => ele.application);
      this.machineTypelist = response.machineType.filter(ele => ele.machine_type != null).map(obj => obj.machine_type);
      this.featurelist = response.specificFeature.map(ele => ele.specific_feature);
      this.controlSystemlist = response.controlSystem.map(ele => ele.control_system);
      if(isDownload) {
        this.createBulkUploadMachineTemplate();
      }
    }, (error) => {
      this.toastService.presentToast(error, 3000, AppConstants.ERROR_SNACKBAR, 'top');
    });
  }
  /**
   * Creates bulk upload machine template
   */
  private createBulkUploadMachineTemplate() {
    const workbook = new Workbook();
    // Main sheet
    const worksheet = workbook.addWorksheet(this.translateWithFallback('Machine Library'));
    // Hidden sheet for dropdown lists
    const listSheet = workbook.addWorksheet('Lists');
    listSheet.state = 'veryHidden';
    // Headers
    this.header = [
      this.translateWithFallback('Machine Name'),
      this.translateWithFallback('Description'),
      this.translateWithFallback('Customer Id'),
      this.translateWithFallback('Application'),
      this.translateWithFallback('Machine Type'),
      this.translateWithFallback('Specific Features'),
      this.translateWithFallback('Control System'),
      this.translateWithFallback('Machine Mode'),
      this.translateWithFallback('Manufacturer'),
      this.translateWithFallback('Model'),
      this.translateWithFallback('Serial Number'),
      this.translateWithFallback('Asset Number')
    ];
    const headerRow = worksheet.addRow(this.header);
    headerRow.font = { color: { argb: 'FFFFFF' } };
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '083a81' },
      };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };
    });
    worksheet.properties.defaultColWidth = 25;
    // Populate hidden list sheet
    this.applicationlist.forEach((val, idx) => listSheet.getCell(`A${idx + 1}`).value = val);
    this.machineTypelist.forEach((val, idx) => listSheet.getCell(`B${idx + 1}`).value = val);
    this.featurelist.forEach((val, idx) => listSheet.getCell(`C${idx + 1}`).value = val);
    this.controlSystemlist.forEach((val, idx) => listSheet.getCell(`D${idx + 1}`).value = val);
    this.machinemodelist.forEach((val, idx) => listSheet.getCell(`E${idx + 1}`).value = val);
    // Add dropdown data validation referencing hidden sheet
    for (let i = 2; i <= 20; i++) {
      worksheet.getCell(`D${i}`).dataValidation = {
        type: 'list',
        allowBlank: true,
        formulae: [`Lists!$A$1:$A$${this.applicationlist.length}`]
      };
      worksheet.getCell(`E${i}`).dataValidation = {
        type: 'list',
        allowBlank: true,
        formulae: [`Lists!$B$1:$B$${this.machineTypelist.length}`]
      };
      worksheet.getCell(`F${i}`).dataValidation = {
        type: 'list',
        allowBlank: true,
        formulae: [`Lists!$C$1:$C$${this.featurelist.length}`]
      };
      worksheet.getCell(`G${i}`).dataValidation = {
        type: 'list',
        allowBlank: true,
        formulae: [`Lists!$D$1:$D$${this.controlSystemlist.length}`]
      };
      worksheet.getCell(`H${i}`).dataValidation = {
        type: 'list',
        allowBlank: true,
        formulae: [`Lists!$E$1:$E$${this.machinemodelist.length}`]
      };
    }
    // Make "Customer Id" column text format
    worksheet.getColumn(3).eachCell({ includeEmpty: true }, cell => {
      cell.numFmt = '@';
    });
    // Export the Excel file
    workbook.xlsx.writeBuffer().then((machines) => {
      const blob = new Blob([machines], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'MachineBulkUpload.xlsx');
    });
  }

  private translateWithFallback(key: string): string {
    const translated = this.translate.instant(key);
    return translated && translated !== key ? translated : key;
  }

  /**
   * Downloads bulk upload machine template
   */
  public downloadBulkUploadMachineTemplate() {
    this.getMachineReferencesForBulkUpload(true);
  }

  downloadInitialHazardTemplate() {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet(this.translateWithFallback('Initial Hazards'));
    this.header = [
      this.translateWithFallback('Initial Hazard Value'),
      this.translateWithFallback('Language')
    ];
    const headerRow = worksheet.addRow(this.header);
    headerRow.font = { color: { argb: 'FFFFFF' } };
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '083a81' },
      };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });
    worksheet.properties.defaultColWidth = 50;
    this.applyLanguageDropdown(worksheet, 'B');
    workbook.xlsx.writeBuffer().then((initialHazards) => {
      const blob = new Blob([initialHazards], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'Initial_Hazard_Template.xlsx');
    });
  }

   downloadTemplate(sheetName,headers,data,filename) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet(sheetName);
    const headerRow = worksheet.addRow(headers);
    headerRow.font = { color: { argb: 'FFFFFF' } };
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '083a81' },
      };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });
    worksheet.properties.defaultColWidth = 50;
    workbook.xlsx.writeBuffer().then((sectors) => {
      const blob = new Blob([sectors], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, filename);
    });
  }

  downloadMeasureTemplate() {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet(this.translateWithFallback('Measures'));
    this.header = [
      this.translateWithFallback('Measure Value'),
      this.translateWithFallback('Measure Type'),
      this.translateWithFallback('Language')
    ];
    const headerRow = worksheet.addRow(this.header);
    headerRow.font = { color: { argb: 'FFFFFF' } };
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '083a81' },
      };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });
    worksheet.properties.defaultColWidth = 50;
    this.measureTypeList = this.sharedValue.measureTypes.map(ele => this.getTranslatedMeasureTypeLabel(ele?.measure_type_name));
    const joinedMeasureTypes = '"' + this.measureTypeList.join(',') + '"';
    for (let i = 2; i < 20; i++) {
      worksheet.getCell('B' + i).dataValidation = {
        type: 'list',
        allowBlank: true,
        formulae: [joinedMeasureTypes]
      };
    }
    this.applyLanguageDropdown(worksheet, 'C');
    workbook.xlsx.writeBuffer().then((controlMeasures) => {
      const blob = new Blob([controlMeasures], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'Measure_Template.xlsx');
    });
  }

  /**
   * Adds a list-validation (dropdown) on the given column for the first 19 data
   * rows of `worksheet`. Each option is rendered as 'Label (code)' (e.g.
   * 'Spanish (sp)') so the user can see the app-internal code that will be
   * stored against each row.
   */
  private applyLanguageDropdown(worksheet: any, column: string): void {
    const options = appLanguageOptions
      .filter(lang => lang?.label && lang?.code)
      .map(lang => `${lang.label} (${lang.code})`);
    if (!options.length) { return; }
    const formula = '"' + options.join(',') + '"';
    for (let i = 2; i < 20; i++) {
      worksheet.getCell(`${column}${i}`).dataValidation = {
        type: 'list',
        allowBlank: true,
        formulae: [formula]
      };
    }
  }

  private getTranslatedMeasureTypeLabel(measureTypeName: string): string {
    if (!measureTypeName || typeof measureTypeName !== 'string') {
      return measureTypeName;
    }

    return this.translateWithFallback(getMeasureTypeTranslationKey(measureTypeName));
  }

  private findMeasureTypeByUploadValue(measureTypeName: string) {
    const normalizedMeasureType = (measureTypeName || '').trim();
    if (!normalizedMeasureType) {
      return null;
    }

    return this.sharedValue.measureTypes.find(measureType => {
      const canonicalLabel = (measureType?.measure_type_name || '').trim();
      const translatedLabel = this.getTranslatedMeasureTypeLabel(canonicalLabel)?.trim();
      return canonicalLabel.toLowerCase() === normalizedMeasureType.toLowerCase()
        || translatedLabel?.toLowerCase() === normalizedMeasureType.toLowerCase();
    }) || null;
  }

  /**
   * Maps a user-entered Language cell from the bulk-upload sheet to the
   * app-internal language code (e.g. "Spanish (sp)" -> "sp",
   * "English" -> "en", "sp" -> "sp"). Returns '' when blank or unrecognized
   * so the backend can fall back to its default.
   */
  private resolveLanguageCode(rawValue: any): string {
    const value = (rawValue ?? '').toString().trim();
    if (!value) { return ''; }
    // Pull a trailing '(code)' if the dropdown format is used.
    const parenMatch = value.match(/\(([^()]+)\)\s*$/);
    const candidates = [value.toLowerCase()];
    if (parenMatch) {
      candidates.push(parenMatch[1].trim().toLowerCase());
      candidates.push(value.replace(/\s*\([^()]*\)\s*$/, '').trim().toLowerCase());
    }
    const match = appLanguageOptions.find(lang =>
      candidates.includes(lang.label.toLowerCase()) ||
      candidates.includes(lang.code.toLowerCase())
    );
    return match ? match.code : '';
  }

  public downloadRoadmapTemplate(hideDescription: boolean = false) {
    const headers = [
      this.translate.instant('Roadmap Name'),
      this.translate.instant('Section Name'),
      this.translate.instant('Subsection'),
      this.translate.instant('step'),
      this.translate.instant('Roadmap Version')
    ];

    if (!hideDescription) {
      headers.splice(1, 0, this.translate.instant('Description'));
    }

    this.downloadTemplate(
      this.translate.instant('Roadmap Library'),
      headers,
      null,
      'RoadMap File Template .xlsx'
    );
  }

  async checkFolderExists(name) {
    const folderPath = name;
    const folderCreatePayload = {
      name,
      folder: {},
      '@microsoft.graph.conflictBehavior': 'rename'
    };
    this.graphService.getBluePrintCommunicationFolderDetails(name).subscribe((res: any) => {
      if (res) {
        if (res.value.filter(function (e) { return e.name === name; }).length == 0) {
          this.graphService.createBluePrintCommunicationSiteFolder(folderCreatePayload, folderPath).subscribe(() => {
          });
        }
      }
    });
  }

  async createFolder(folderPath, name) {
    const folderCreatePayload = {
      name,
      folder: {},
      '@microsoft.graph.conflictBehavior': 'rename'
    };
    this.graphService.createFolder(folderCreatePayload, folderPath).subscribe((res) => {
    });
  }

  getUserList() {
    const user = {
      name: '',
      userId: '',
      email: '',
      roles: []
    };
    const userInfo = this.getUserInfoFromLocal();
    if (userInfo) {
      user.name = userInfo.name;
      user.userId = userInfo.userId;
      user.email = userInfo.email;
      user.roles = userInfo.roleAssignmentInfo;
    }
    this.UserId = user.userId;
    return user;

  }

  getUserInfoFromLocal() {
    return this.localSettingsSrv.getuserInfo('userLists');
  }

  //machineUpload File
  onUploadChange(evt: any) {
    const files = evt.target.files;
    if (!this.validateFile(files[0].name)) {
      this.toastService.presentToast(this.translate.instant('selected_file_format_not_supported'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
      return false;
    }
    if (isNotEmptyArray(this.master)) { this.master = []; }
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) { throw new Error('Cannot use multiple files'); }
    const file = evt.target.files[0];
    const fileName = evt.target.files[0].name;
    const fileSize = evt.target.files[0].size;
    const reader: FileReader = new FileReader();
    reader.onload = async (e: any) => {
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
      this.data = <AOA>(XLSX.utils.sheet_to_json(ws, { header: 1 }));
      this.bulkMachinePayload = [];
      for (let i = 0; i <= this.data.length; i++) {
        if (i > 0 && isNotEmptyArray(this.data[i])) {
          if (this.data[i][0] == null) {
            this.toastService.presentToast(this.translate.instant('machine_name_required'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
            return false;
          } else if (this.data[i][2] == null) {
            this.toastService.presentToast(this.translate.instant('customer_id_required'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
            return false;
          } else if (this.data[i][3] == null) {
            this.toastService.presentToast(this.translate.instant('application_required'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
            return false;
          } else if (this.data[i][4] == null) {
            this.toastService.presentToast(this.translate.instant('machine_type_required'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
            return false;
          } else if (this.data[i][5] == null) {
            this.toastService.presentToast(this.translate.instant('specific_feature_required'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
            return false;
          } else if (this.data[i][6] == null) {
            this.toastService.presentToast(this.translate.instant('control_system_required'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
            return false;
          } else if (this.data[i][7] == null) {
            this.toastService.presentToast(this.translate.instant('machine_mode_required'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
            return false;
          }
          else {
            const machineMetaData = [];
            const createMachine: any = {};
            const machineAttributes: any = {};
            const application = this.applications.find(item => item.application == this.data[i][3]);
            const machineType = this.machineTypes.find(item => item.machine_type == this.data[i][4]);
            const specificFeature = this.features.find(item => item.specific_feature == this.data[i][5]);
            const controlSystem = this.controlSystems.find(item => item.control_system == this.data[i][6]);
            const machineMode = this.machineModes.find(item => item.name == this.data[i][7]);
            // Read data from sheet and preparing payload to call MasterMachineFileUploadJson API
            createMachine.machine_Name = this.data[i][0];
            createMachine.description = this.data[i][1] ? this.data[i][1] : '';
            createMachine.customer_Id = this.data[i][2] ? this.data[i][2].toString() : '';
            machineAttributes.application = application?.id;
            machineAttributes.machineType = machineType?.id;
            machineAttributes.specificFeature = specificFeature?.id?.split(' ');
            machineAttributes.controlSystem = controlSystem?.id?.split(' ');
            createMachine.machineModes = machineMode?.id?.split(' ');
            machineMetaData.push(machineAttributes);
            createMachine.machineMetaData = machineMetaData;
            createMachine.model = this.data[i][9] ? this.data[i][9].toString() : '';
            createMachine.manufacturer = this.data[i][8] ? this.data[i][8].toString() : '';
            createMachine.serial_Number = this.data[i][10] ? this.data[i][10].toString() : '';
            createMachine.asset_Number = this.data[i][11] ? this.data[i][11].toString() : '';
            createMachine.machineImage = [];
            this.bulkMachinePayload.push(createMachine);
          }
        }
      }
      if (this.bulkMachinePayload.length == 0) {
        //this.sharedValue.errorShowToast('Upload Failed', 'Data does not exist');
        //this.toastService.presentToast('Data does not exist', 4000, AppConstants.ERROR_SNACKBAR, 'top');
        this.toastService.presentToast(this.translate.instant('please_add_data_in_sheet'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
        setTimeout(() => {
          this.eventProvider.BroadcastEvent(ObservationEvents.ERROR_OCCURRED, 'error');
        }, 3000);
        return false;
      } else {
        const fileSize = evt.target.files[0].size;
        setTimeout(() => {
          this.bulkUploadMachine();
        }, 200);
        this.isButtonEnable = true;
      }
    };
    reader.readAsBinaryString(target.files[0]); {
    }
  }

  async bulkUploadMachine() {
    this.backendService.createMachine(this.bulkMachinePayload).then((res: any) => {
      if (res.value.statusReason == 'Machine\'s created successfully') {
        this.toastService.presentToast(this.translate.instant('machines_uploaded_successfully'), 4000, AppConstants.SUCCESS_SNACKBAR, 'top');
        this.eventProvider.BroadcastEvent(ObservationEvents.FILE_UPLOAD_SUCCESS, 'uploadDone');
      } else {
        this.toastService.presentToast(res.value.statusReason, 4000, AppConstants.ERROR_SNACKBAR, 'top');
        setTimeout(() => {
          this.eventProvider.BroadcastEvent(ObservationEvents.ERROR_OCCURRED, 'error');
        }, 3000);
      }
    }).catch((err) => {
      this.toastService.presentToast(this.translate.instant('something_went_wrong'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
      this.eventProvider.BroadcastEvent(ObservationEvents.ERROR_OCCURRED, 'error');
    });
  }

  async UploadFileToSharePoint(folderPath, fileName, file, fileSize, type) {
    this.uploadFileList = []
    if (fileSize < 4194304) {
      this.graphService.UploadFileToCommmicationSite(fileName, file, folderPath).subscribe((res: any) => {
        if (res) {
          this.uploadFileName = res.name;
          if (type == 'Legislation Documents') {
            const data = {
              id: res.id,
              name: res.name,
              type: 'Legislations',
              url: res['@microsoft.graph.downloadUrl'], //res.webUrl
              driveId: res.parentReference.driveId,
              itemId: res.id
            };
            this.uploadFileList.push(data);
            const payload = this.uploadFileList;
            this.backendService.isUploadlegislationReport(payload).subscribe(
              (response: any) => {
                if (response.statusReason == 'File saved Successfully') {
                  this.toastService.presentToast(this.translate.instant('file_saved_successfully'), 4000, AppConstants.SUCCESS_SNACKBAR, 'top');
                  this.eventProvider.BroadcastEvent(ObservationEvents.FILE_UPLOAD_SUCCESS, 'uploadDone');
                }
                else {
                  this.toastService.presentToast(this.translate.instant('failed_save_file'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
                  this.eventProvider.BroadcastEvent(ObservationEvents.ERROR_OCCURRED, 'error');
                }
              }, err => {
                this.toastService.presentToast(this.translate.instant('no_results_found'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
                this.eventProvider.BroadcastEvent(ObservationEvents.ERROR_OCCURRED, 'error');
              });

          }
          else if (type == 'Standard Documents') {
            const data = {
              id: res.id,
              name: res.name,
              type: 'Standards',
              url: res['@microsoft.graph.downloadUrl'], //res.webUrl
              driveId: res.parentReference.driveId,
              itemId: res.id
            };
            this.uploadFileList.push(data);
            const payload = this.uploadFileList;
            this.backendService.isUploadlegislationReport(payload).subscribe(
              (response: any) => {
                console.log(response);
                if (response.statusReason == 'File saved Successfully') {
                  this.toastService.presentToast(this.translate.instant('file_saved_successfully'), 4000, AppConstants.SUCCESS_SNACKBAR, 'top');
                  this.eventProvider.BroadcastEvent(ObservationEvents.FILE_UPLOAD_SUCCESS, 'uploadDone');
                } else {
                  this.toastService.presentToast(this.translate.instant('failed_save_file'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
                  this.eventProvider.BroadcastEvent(ObservationEvents.ERROR_OCCURRED, 'error');
                }
              }, err => {
                this.eventProvider.BroadcastEvent(ObservationEvents.ERROR_OCCURRED, 'error');
                this.toastService.presentToast(this.translate.instant('no_results_found'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
              });
          }
          else if (type == 'Quote Templates') {
            const data = {
              id: res.id,
              name: res.name,
              type: 'quoteLibrary',
              url: res['@microsoft.graph.downloadUrl'], //res.webUrl
              driveId: res.parentReference.driveId,
              itemId: res.id
            };
            this.uploadFileList.push(data);
            const payload = this.uploadFileList;
            this.backendService.isUploadlegislationReport(payload).subscribe(
              (response: any) => {
                if (response.statusReason == 'File saved Successfully') {
                  // this.sharedValue.showToast('', 'Data Saved succesfully');
                }
                else {
                  this.toastService.presentToast(this.translate.instant('failed_save_file'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
                }
              }, err => {
                this.toastService.presentToast(this.translate.instant('no_results_found'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
              });
          }
          else if (type == 'Risk Assessment Report Template Library') {
            const data = {
              id: res.id,
              name: res.name,
              type: 'riskAssesment',
              url: res['@microsoft.graph.downloadUrl'], //res.webUrl
              driveId: res.parentReference.driveId,
              itemId: res.id
            };
            this.uploadFileList.push(data);
            const payload = this.uploadFileList;
            this.backendService.isUploadlegislationReport(payload).subscribe(
              (response: any) => {
                if (response.statusReason == 'File saved Successfully') {
                  // this.sharedValue.showToast('', 'Data Saved succesfully');
                }
                else {
                  this.toastService.presentToast(this.translate.instant('failed_save_file'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
                }
              }, err => {
                this.toastService.presentToast(this.translate.instant('no_results_found'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
              });
          }
          else if (type == 'Machine Library') {
            const data = {
              id: res.id,
              name: res.name,
              type: 'MachineLibrary',
              url: res['@microsoft.graph.downloadUrl'], //res.webUrl
              driveId: res.parentReference.driveId,
              itemId: res.id
            };
            this.uploadFileList.push(data);
            const payload = this.uploadFileList;
            this.backendService.isUploadlegislationReport(payload).subscribe(
              (response: any) => {
                if (response.statusReason == 'File saved Successfully') {
                  // this.sharedValue.showToast('', 'Data Saved succesfully');
                }
                else {
                  this.toastService.presentToast(this.translate.instant('failed_save_file'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
                }
              }, err => {
                this.toastService.presentToast(this.translate.instant('no_results_found'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
              });
          }
          else if (type == 'Roadmap Library') {
            const data = {
              id: res.id,
              name: res.name,
              type: 'RoadMapLibrary',
              url: res['@microsoft.graph.downloadUrl'], //res.webUrl
              driveId: res.parentReference.driveId,
              itemId: res.id
            };
            this.uploadFileList.push(data);
            const payload = this.uploadFileList;
            this.backendService.isUploadlegislationReport(payload).subscribe(
              (response: any) => {
                if (response.statusReason == 'File saved Successfully') {
                  data.id = response.id;
                  this.dismissRoadMapModal();
                  this.eventProvider.BroadcastEvent(ObservationEvents.FILE_UPLOAD_SUCCESS, 'uploadDone');
                } else if (response.statusReason == 'File Updated Successfully') {
                  data.id = response.id;
                  this.eventProvider.BroadcastEvent(ObservationEvents.FILE_UPLOAD_SUCCESS, 'uploadDone');
                }
                else {
                  this.toastService.presentToast(this.translate.instant('failed_save_file'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
                  this.eventProvider.BroadcastEvent(ObservationEvents.ERROR_OCCURRED, 'error');
                }
              }, err => {
                this.eventProvider.BroadcastEvent(ObservationEvents.ERROR_OCCURRED, 'error');
                this.toastService.presentToast(this.translate.instant('no_results_found'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
              });
          }
          else if (type == HazardMeasureConstants.MEASURES) {
            const data = {
              id: res.id,
              name: res.name,
              type: 'ControlMeasures',
              url: res['@microsoft.graph.downloadUrl'], //res.webUrl
              driveId: res.parentReference.driveId,
              itemId: res.id
            };
            this.uploadFileList.push(data);
            const payload = this.uploadFileList;
            this.backendService.isUploadlegislationReport(payload).subscribe(
              (response: any) => {
                if (!this.isFileArchiveSuccess(response)) {
                  this.logHazardMeasureArchiveWarning(response);
                }
              }, err => {
                this.logHazardMeasureArchiveWarning(err);
              });
          }
          else if (type == 'Initial Hazards') {
            const data = {
              id: res.id,
              name: res.name,
              type: 'InitialHazards',
              url: res['@microsoft.graph.downloadUrl'], //res.webUrl
              driveId: res.parentReference.driveId,
              itemId: res.id
            };
            this.uploadFileList.push(data);
            const payload = this.uploadFileList;
            this.backendService.isUploadlegislationReport(payload).subscribe(
              (response: any) => {
                if (!this.isFileArchiveSuccess(response)) {
                  this.logHazardMeasureArchiveWarning(response);
                }
              }, err => {
                this.logHazardMeasureArchiveWarning(err);
              });
          }
        }
      }, err => {
        // this.sharedValue.errorShowToast("","No Results Found")
      });
    } else if (fileSize < 94371840) {
      this.graphService.createUploadSessionInCommmicationSite(fileName, fileSize, folderPath).subscribe((res: any) => {
        if (res.uploadUrl) {
          this.sharedValue.uploadChunks(file, res.uploadUrl).then((res: any) => {
            if (res?.[1]) {
              this.uploadFileName = res[1].name;
              if (type == 'Legislation Documents') {
                const data = {
                  id: res[1].id,
                  name: res[1].name,
                  type: 'Legislations',
                  url: res[1]['@microsoft.graph.downloadUrl'], //res.webUrl
                  driveId: res[1].parentReference.driveId,
                  itemId: res[1].id
                };
                this.uploadFileList.push(data);
                const payload = this.uploadFileList;
                this.backendService.isUploadlegislationReport(payload).subscribe(
                  (response: any) => {
                    if (response.statusReason == 'File saved Successfully') {
                      this.toastService.presentToast(this.translate.instant('file_saved_successfully'), 4000, AppConstants.SUCCESS_SNACKBAR, 'top');
                      this.eventProvider.BroadcastEvent(ObservationEvents.FILE_UPLOAD_SUCCESS, 'uploadDone');
                    }
                    else {
                      this.toastService.presentToast(this.translate.instant('failed_save_file'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
                      this.eventProvider.BroadcastEvent(ObservationEvents.ERROR_OCCURRED, 'error');
                    }
                  }, err => {
                    this.toastService.presentToast(this.translate.instant('no_results_found'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
                    this.eventProvider.BroadcastEvent(ObservationEvents.ERROR_OCCURRED, 'error');
                  });

              }
              else if (type == 'Standard Documents') {
                const data = {
                  id: res[1].id,
                  name: res[1].name,
                  type: 'Standards',
                  url: res[1]['@microsoft.graph.downloadUrl'], //res.webUrl
                  driveId: res[1].parentReference.driveId,
                  itemId: res[1].id
                };
                this.uploadFileList.push(data);
                const payload = this.uploadFileList;
                this.backendService.isUploadlegislationReport(payload).subscribe(
                  (response: any) => {
                    if (response.statusReason == 'File saved Successfully') {
                      this.toastService.presentToast(this.translate.instant('file_saved_successfully'), 4000, AppConstants.SUCCESS_SNACKBAR, 'top');
                      this.eventProvider.BroadcastEvent(ObservationEvents.FILE_UPLOAD_SUCCESS, 'uploadDone');
                    } else {
                      this.toastService.presentToast(this.translate.instant('failed_save_file'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
                      this.eventProvider.BroadcastEvent(ObservationEvents.ERROR_OCCURRED, 'error');
                    }
                  }, err => {
                    this.eventProvider.BroadcastEvent(ObservationEvents.ERROR_OCCURRED, 'error');
                    this.toastService.presentToast(this.translate.instant('no_results_found'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
                  });
              }
              else if (type == 'Quote Template Library') {
                const data = {
                  id: res[1].id,
                  name: res[1].name,
                  type: 'quoteLibrary',
                  url: res[1]['@microsoft.graph.downloadUrl'], //res.webUrl
                  driveId: res[1].parentReference.driveId,
                  itemId: res[1].id
                };
                this.uploadFileList.push(data);
                const payload = this.uploadFileList;
                this.backendService.isUploadlegislationReport(payload).subscribe(
                  (response: any) => {
                    if (response.statusReason == 'File saved Successfully') {
                    }
                    else {
                      this.toastService.presentToast(this.translate.instant('failed_save_file'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
                    }
                  }, err => {
                    this.toastService.presentToast(this.translate.instant('no_results_found'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
                  });
              }
              else if (type == 'Risk Assessment Report Template Library') {
                const data = {
                  id: res[1].id,
                  name: res[1].name,
                  type: 'riskAssesment',
                  url: res[1]['@microsoft.graph.downloadUrl'], //res.webUrl
                  driveId: res[1].parentReference.driveId,
                  itemId: res[1].id
                };
                this.uploadFileList.push(data);
                const payload = this.uploadFileList;
                this.backendService.isUploadlegislationReport(payload).subscribe(
                  (response: any) => {
                    if (response.statusReason == 'File saved Successfully') {
                    }
                    else {
                      this.toastService.presentToast(this.translate.instant('failed_save_file'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
                    }
                  }, err => {
                    this.toastService.presentToast(this.translate.instant('no_results_found'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
                  });
              }
              else if (type == 'Machine Library') {
                const data = {
                  id: res[1].id,
                  name: res[1].name,
                  type: 'MachineLibrary',
                  url: res[1]['@microsoft.graph.downloadUrl'], //res.webUrl
                  driveId: res[1].parentReference.driveId,
                  itemId: res[1].id
                };
                this.uploadFileList.push(data);
                const payload = this.uploadFileList;
                this.backendService.isUploadlegislationReport(payload).subscribe(
                  (response: any) => {
                    if (response.statusReason == 'File saved Successfully') {
                      // this.sharedValue.showToast('', 'Data Saved succesfully');
                    }
                    else {
                      this.toastService.presentToast(this.translate.instant('failed_save_file'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
                    }
                  }, err => {
                    this.toastService.presentToast(this.translate.instant('no_results_found'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
                  });
              }
              else if (type == 'Roadmap Library') {
                const data = {
                  id: res[1].id,
                  name: res[1].name,
                  type: 'RoadMapLibrary',
                  url: res[1]['@microsoft.graph.downloadUrl'], //res.webUrl
                  driveId: res[1].parentReference.driveId,
                  itemId: res[1].id
                };
                this.uploadFileList.push(data);
                const payload = this.uploadFileList;
                this.backendService.isUploadlegislationReport(payload).subscribe(
                  (response: any) => {
                    if (response.statusReason == 'File saved Successfully') {
                      data.id = response.id;
                      this.dismissRoadMapModal();
                      this.eventProvider.BroadcastEvent(ObservationEvents.FILE_UPLOAD_SUCCESS, 'uploadDone');
                    } else if (response.statusReason == 'File Updated Successfully') {
                      data.id = response.id;
                      this.eventProvider.BroadcastEvent(ObservationEvents.FILE_UPLOAD_SUCCESS, 'uploadDone');
                    }
                    else {
                      this.toastService.presentToast(this.translate.instant('failed_save_file'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
                      this.eventProvider.BroadcastEvent(ObservationEvents.ERROR_OCCURRED, 'error');
                    }
                  }, err => {
                    this.eventProvider.BroadcastEvent(ObservationEvents.ERROR_OCCURRED, 'error');
                    this.toastService.presentToast(this.translate.instant('no_results_found'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
                  });
              }
              else if (type == HazardMeasureConstants.MEASURES) {
                const data = {
                  id: res[1].id,
                  name: res[1].name,
                  type: 'ControlMeasures',
                  url: res[1]['@microsoft.graph.downloadUrl'], //res.webUrl
                  driveId: res[1].parentReference.driveId,
                  itemId: res[1].id
                };
                this.uploadFileList.push(data);
                const payload = this.uploadFileList;
                this.backendService.isUploadlegislationReport(payload).subscribe(
                  (response: any) => {
                    if (!this.isFileArchiveSuccess(response)) {
                      this.logHazardMeasureArchiveWarning(response);
                    }
                  }, err => {
                    this.logHazardMeasureArchiveWarning(err);
                  });
              }
              else if (type == 'Initial Hazards') {
                const data = {
                  id: res[1].id,
                  name: res[1].name,
                  type: 'InitialHazards',
                  url: res[1]['@microsoft.graph.downloadUrl'], //res.webUrl
                  driveId: res[1].parentReference.driveId,
                  itemId: res[1].id
                };
                this.uploadFileList.push(data);
                const payload = this.uploadFileList;
                this.backendService.isUploadlegislationReport(payload).subscribe(
                  (response: any) => {
                    if (!this.isFileArchiveSuccess(response)) {
                      this.logHazardMeasureArchiveWarning(response);
                    }
                  }, err => {
                    this.logHazardMeasureArchiveWarning(err);
                  });
              }
            }
          });
        } else if (res.error) {
          this.toastService.presentToast(res.error?.message, 4000, AppConstants.ERROR_SNACKBAR, 'top', 'error_occurred');
        }
      });
    } else {
      this.toastService.presentToast(this.translate.instant('image_size_exceeds_100mb'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
    }
  }

  async presentLoading(msg) {
    const loading = await this.loadingController.create({
      cssClass: 'my-custom-loading',
      message: msg,
      spinner: 'bubbles'
    });
    await loading.present();
    return loading;
  }

  //RoadMapUpload File
  onRoadMapUpload(evt: any, type?: string, hideDescription: boolean = false) {
    this.type = type;
    const files = evt.target.files;
    if (!this.validateFile(files[0].name)) {
      this.toastService.presentToast(this.translate.instant('selected_file_format_not_supported'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
      return false;
    }
    if (isNotEmptyArray(this.roadMapData)) { this.roadMapData = []; }
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) { throw new Error('Cannot use multiple files'); }
    const file = evt.target.files[0];
    const fileName = evt.target.files[0].name;
    const fileSize = evt.target.files[0].size;
    const reader: FileReader = new FileReader();
    reader.onload = async (e: any) => {
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
      this.data = <AOA>(XLSX.utils.sheet_to_json(ws, { header: 1 }));
      if (isNotEmptyArray(this.data)) {
        const isEVeryFieldEnterd = await this.checkAllFieldsEntered(hideDescription);
        if (!isEVeryFieldEnterd) {
          this.toastService.presentToast(this.translate.instant('all_fields_mandatory_check_upload_file'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
          setTimeout(() => {
            this.eventProvider.BroadcastEvent(ObservationEvents.FILE_VALIDATION_ERROR, 'validationError');
          }, 2000);
          return false;
        }
        this.roadMapData = await this.createRoadmapPayload(hideDescription);
        if (isEmptyArray(this.roadMapData)) {
          //this.sharedValue.errorShowToast('Upload Failed', 'Data does not exist');
          this.toastService.presentToast(this.translate.instant('please_add_data_in_sheet'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
          setTimeout(() => {
            this.eventProvider.BroadcastEvent(ObservationEvents.ERROR_OCCURRED, 'error');
          }, 3000);
          //this.toastService.presentToast('Data does not exist in the uploaded file', 4000, AppConstants.ERROR_SNACKBAR, 'top');
          return false;
        } else {
          this.isButtonEnable = true;
          //Upload file to share Point
          const fileSize = evt.target.files[0].size;
          const UploadImageFolderPath = roadmapLibrary;
          await this.checkFolderExists(UploadImageFolderPath);
          const extFileName = fileName.split('.').slice(0, -1).join('.');
          const finalFileName = extFileName + '.xls';
          // const finalFileName = extFileName + "_" + Math.floor((Math.random() * 10987867960) + 1) + ".xls";
          await this.UploadFileToSharePoint(UploadImageFolderPath, finalFileName, file, fileSize, this.type);
        };
      }
    };
    reader.readAsBinaryString(target.files[0]);
  }

  checkAllFieldsEntered(hideDescription: boolean = false) {
    let isEveryFieldEntered = false;
    const sectionIndex = hideDescription ? 1 : 2;
    const subSectionIndex = hideDescription ? 2 : 3;
    const stepIndex = hideDescription ? 3 : 4;
    const versionIndex = hideDescription ? 4 : 5;

    if (isNotEmptyArray(this.data)) {
      for (let i = 0; i <= this.data.length; i++) {
        if (i > 0 && isNotEmptyArray(this.data[i])) {
          if (
            this.data[i][0] == null ||
            this.data[i][sectionIndex] == null ||
            this.data[i][subSectionIndex] == null ||
            this.data[i][stepIndex] == null ||
            this.data[i][versionIndex] == null
          ) {
            isEveryFieldEntered = false;
          } else { isEveryFieldEntered = true; }
        }
      }
    }
    return isEveryFieldEntered;
  }


  createRoadmapPayload(hideDescription: boolean = false) {
    const roadmapFinalPayload = [];
    const sectionIndex = hideDescription ? 1 : 2;
    const subSectionIndex = hideDescription ? 2 : 3;
    const stepIndex = hideDescription ? 3 : 4;
    const versionIndex = hideDescription ? 4 : 5;
    if (isNotEmptyArray(this.data)) {
      const payloadStructure = {
        roadMapMasterId: '',
        roadMapName: '',
        roadMapVersion: '',
        description: '',
        roadMapSections: [
          {
            roadMapSectionId: '',
            roadMapMasterId: '',
            sectionName: '',
            roadMapSubSection: [
              {
                roadMapSubSectionId: '',
                roadMapSectionId: '',
                subSectionName: '',
                stepMaster: [
                  {
                    stepMasterId: '',
                    stepBody: ''
                  }
                ]
              }
            ]
          }
        ]
      };
      const excelPayload = JSON.parse(JSON.stringify(this.data));
      excelPayload.forEach((_exd, index) => {
        if (index > 0) {
          if (isNotEmptyArray(roadmapFinalPayload)) {
            const matchedRoadmap = roadmapFinalPayload.find(_rfp => _rfp.roadMapName == _exd[0]);
            if (matchedRoadmap && matchedRoadmap.roadMapName) {
              //roadmap existing
              const matchedSection = matchedRoadmap.roadMapSections.find(_sec => _sec.sectionName == _exd[sectionIndex]);
              if (matchedSection && matchedSection.sectionName) {
                //section name existing
                const matchedSubSection = matchedSection.roadMapSubSection.find(_subsec => _subsec.subSectionName == _exd[subSectionIndex]);
                if (matchedSubSection && matchedSubSection.subSectionName) {
                  //sub section name existing
                  const matchedStepMaster = matchedSubSection.stepMaster.find(_smaster => _smaster.stepBody == _exd[stepIndex]);
                  if (!matchedStepMaster) {
                    // new step body to push
                    const pStructure = JSON.parse(JSON.stringify(payloadStructure));
                    const newStepMaster = pStructure.roadMapSections[0]?.roadMapSubSection[0]?.stepMaster[0];
                    newStepMaster.stepBody = _exd[stepIndex]?.toString();
                    matchedSubSection.stepMaster.push(newStepMaster);
                  }
                } else {
                  //new subsection to push
                  const pStructure = JSON.parse(JSON.stringify(payloadStructure));
                  const newSubSection = pStructure.roadMapSections[0].roadMapSubSection[0];
                  newSubSection.subSectionName = _exd[subSectionIndex]?.toString();
                  newSubSection.stepMaster[0].stepBody = _exd[stepIndex]?.toString();
                  matchedSection.roadMapSubSection.push(newSubSection);
                }
              } else {
                // new section to push
                const pStructure = JSON.parse(JSON.stringify(payloadStructure));
                const newSection = pStructure.roadMapSections[0];
                newSection.sectionName = _exd[sectionIndex]?.toString();
                newSection.roadMapSubSection[0].subSectionName = _exd[subSectionIndex]?.toString();
                newSection.roadMapSubSection[0].stepMaster[0].stepBody = _exd[stepIndex]?.toString();
                matchedRoadmap.roadMapSections.push(newSection);
              }
            } else {
              // new roadmap, push new value
              this.insertRoadmapValue(payloadStructure, _exd, roadmapFinalPayload, hideDescription);
            }
          } else {
            // insert roadmap info for the first time
            this.insertRoadmapValue(payloadStructure, _exd, roadmapFinalPayload, hideDescription);
          }
        }
      });
    }
    return roadmapFinalPayload;
  }

  insertRoadmapValue(payloadStructure, excelValue, roadmapFinalPayload, hideDescription: boolean = false) {
    const pStructure = JSON.parse(JSON.stringify(payloadStructure));
    const sectionIndex = hideDescription ? 1 : 2;
    const subSectionIndex = hideDescription ? 2 : 3;
    const stepIndex = hideDescription ? 3 : 4;
    const versionIndex = hideDescription ? 4 : 5;
    pStructure.roadMapName = excelValue[0]?.toString() ?? '';
    pStructure.description = hideDescription ? '' : excelValue[1]?.toString() ?? '';
    pStructure.roadMapSections[0].sectionName = excelValue[sectionIndex]?.toString();
    pStructure.roadMapSections[0].roadMapSubSection[0].subSectionName = excelValue[subSectionIndex]?.toString();
    pStructure.roadMapSections[0].roadMapSubSection[0].stepMaster[0].stepBody = excelValue[stepIndex]?.toString();
    pStructure.roadMapVersion = excelValue[versionIndex]?.toString() ?? '';
    roadmapFinalPayload.push(pStructure);
  }


  onUploadIndustrySector(evt: any, type?: string) {
    this.type = type;
    const files = evt.target.files;
    if (!this.validateFile(files[0].name)) {
      this.toastService.presentToast(this.translate.instant('selected_file_format_not_supported'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
      return false;
    }
    if (isNotEmptyArray(this.master)) { this.master = []; }
    const userId = this.UserId;
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) { throw new Error('Cannot use multiple files'); }
    const file = evt.target.files[0];
    const fileName = evt.target.files[0].name;
    const fileSize = evt.target.files[0].size;
    const reader: FileReader = new FileReader();
    reader.onload = async (e: any) => {
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
      this.data = <AOA>(XLSX.utils.sheet_to_json(ws, { header: 1 }));

      for (let i = 0; i <= this.data.length; i++) {
        if (i > 0 && isNotEmptyArray(this.data[i])) {
          if (this.data[i][0] == null || this.data[i][1] == null) {
            this.toastService.presentToast(this.translate.instant('all_fields_mandatory_check_upload_file'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
            setTimeout(() => {
              this.eventProvider.BroadcastEvent(ObservationEvents.ERROR_OCCURRED, 'error');
            }, 3000);
            return false;
          }
          const measureTypeName = (this.data[i][1] + '').trim();
          const matchedMeasureType = this.findMeasureTypeByUploadValue(measureTypeName);

          this.master.push({
            id: '',
            value: '' + this.data[i][0] + '',
            measureType: matchedMeasureType?.measure_type_name ?? measureTypeName,
            measure_type_id: matchedMeasureType?.measure_type_id ?? '',
            userId
          });
        }
      }
      if (this.master.length == 0) {
        this.toastService.presentToast(this.translate.instant('please_add_data_in_sheet'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
        setTimeout(() => {
          this.eventProvider.BroadcastEvent(ObservationEvents.ERROR_OCCURRED, 'error');
        }, 3000);
        return false;
      }
      else {
        this.uploadControlMeaLibrary(fileName, file, fileSize);
      }

    };
    reader.readAsBinaryString(target.files[0]); {
    }
  }

  // Control Measure Documents
  /**
   * Helper: Reset file upload state
   */
  private resetFileUpload(evt: any): void {
    evt.target.value = '';
    this.master = [];
    this.data = [];
  }

  /**
   * Helper: Handle upload errors with consistent formatting
   */
  private handleUploadError(message: string, evt: any, broadcastEvent: string = ObservationEvents.ERROR_OCCURRED): void {
    this.toastService.presentToast(this.translate.instant(message), 4000, AppConstants.ERROR_SNACKBAR, 'top');
    this.resetFileUpload(evt);
    this.eventProvider.BroadcastEvent(broadcastEvent, { toastShown: true });
  }

  private readHazardMeasureSheet(value: string, evt: any): boolean {
    try {
      const workbook = XLSX.read(value, { type: 'binary' });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      if (!sheet) {
        this.handleUploadError('invalid_file', evt, ObservationEvents.FILE_VALIDATION_ERROR);
        return false;
      }
      this.data = <AOA>XLSX.utils.sheet_to_json(sheet, { header: 1 });
      return true;
    } catch (error) {
      console.error('Unable to parse hazard/measure spreadsheet', error);
      this.handleUploadError('invalid_file', evt, ObservationEvents.FILE_VALIDATION_ERROR);
      return false;
    }
  }

  onUploadMeasure(evt: any, type?: string) {
    this.type = type;
    const files = evt.target.files;
    if (!this.validateFile(files[0].name)) {
      this.handleUploadError('selected_file_format_not_supported', evt);
      return false;
    }
    if (isNotEmptyArray(this.master)) this.master = [];
    const userId = this.UserId;
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    const file = evt.target.files[0];
    const fileName = evt.target.files[0].name;
    const fileSize = evt.target.files[0].size;
    const reader = new FileReader();
    reader.onerror = () => this.handleUploadError('invalid_file', evt, ObservationEvents.FILE_VALIDATION_ERROR);
    reader.onabort = () => this.handleUploadError('invalid_file', evt, ObservationEvents.FILE_VALIDATION_ERROR);
    reader.onload = (e: any) => {
      if (!this.readHazardMeasureSheet(e.target.result, evt)) {
        return;
      }

      // Validate file structure
      if (!this.validateExcelFileStructure(this.data, 'Measures').isValid) {
        this.handleUploadError('invalid_file', evt, ObservationEvents.FILE_VALIDATION_ERROR);
        return;
      }

      // Process data rows
      for (let i = 1; i < this.data.length; i++) {
        if (!isNotEmptyArray(this.data[i])) continue;
        if (this.data[i][0] == null || this.data[i][1] == null) {
          this.handleUploadError('all_fields_mandatory_check_upload_file', evt);
          return;
        }
        const measureTypeName = (this.data[i][1] + '').trim();
        const matchedType = this.findMeasureTypeByUploadValue(measureTypeName);
        this.master.push({
          id: '', value: '' + this.data[i][0], measureType: matchedType?.measure_type_name ?? measureTypeName,
          measure_type_id: matchedType?.measure_type_id ?? '', languageCode: this.resolveLanguageCode(this.data[i][2]), userId
        });
      }
      
      if (this.master.length === 0) {
        this.handleUploadError('please_add_data_in_sheet', evt);
        return;
      }
      this.uploadControlMeaLibrary(fileName, file, fileSize);
    };
    reader.readAsBinaryString(target.files[0]);
  }

  onUploadInitialHazard(evt: any, type: any) {
    this.type = type;
    const files = evt.target.files;
    if (!this.validateFile(files[0].name)) {
      this.handleUploadError('selected_file_format_not_supported', evt);
      return false;
    }
    if (isNotEmptyArray(this.master)) this.master = [];
    const target: DataTransfer = <DataTransfer>(evt.target);
    const userId = this.UserId;
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    const file = evt.target.files[0];
    const fileName = evt.target.files[0].name;
    const fileSize = evt.target.files[0].size;
    const reader = new FileReader();
    reader.onerror = () => this.handleUploadError('invalid_file', evt, ObservationEvents.FILE_VALIDATION_ERROR);
    reader.onabort = () => this.handleUploadError('invalid_file', evt, ObservationEvents.FILE_VALIDATION_ERROR);
    reader.onload = (e: any) => {
      if (!this.readHazardMeasureSheet(e.target.result, evt)) {
        return;
      }

      // Validate file structure
      if (!this.validateExcelFileStructure(this.data, 'Initial Hazards').isValid) {
        this.handleUploadError('invalid_file', evt, ObservationEvents.FILE_VALIDATION_ERROR);
        return;
      }

      // Process data rows
      for (let i = 1; i < this.data.length; i++) {
        if (!isNotEmptyArray(this.data[i])) continue;
        if (this.data[i][0] == null) {
          this.handleUploadError('all_fields_mandatory_check_upload_file', evt);
          return;
        }
        this.master.push({
          id: '', value: '' + this.data[i][0],
          languageCode: this.resolveLanguageCode(this.data[i][1]), userId
        });
      }
      
      if (this.master.length === 0) {
        this.handleUploadError('please_add_data_in_sheet', evt);
        return;
      }
      this.UploadInitialHazardLibrary(fileName, file, fileSize);
    };
    reader.readAsBinaryString(target.files[0]);
  }

  upload(event: any) {
    const files = event.target.files;
    if (!this.validateFile(files[0].name)) {
      this.toastService.presentToast(this.translate.instant('selected_file_format_not_supported'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
      return false;
    }
  }

  validateFile(name: string): boolean {
    const ext = name.substring(name.lastIndexOf('.') + 1).toLowerCase();
    if (ext === 'xlsx' || ext === 'xls' || ext === 'csv') {
      return true;
    } else {
      return false;
    }
  }

  /**
   * Validates the Excel file structure based on expected column count and headers
   */
  private validateExcelFileStructure(data: AOA, fileType: string): { isValid: boolean; message?: string } {
    if (!data || data.length === 0) return { isValid: false };
    const headerRow = data[0];
    if (!headerRow || headerRow.length === 0) return { isValid: false };

    const config = { 
      'Measures': { cols: 3, headers: ['Measure Value', 'Measure Type', 'Language'] },
      'Initial Hazards': { cols: 2, headers: ['Initial Hazard Value', 'Language'] }
    }[fileType];

    if (!config || headerRow.length < config.cols) return { isValid: false };

    return config.headers.every((header, index) => {
      const uploadedHeader = this.normalizeUploadHeader(headerRow[index]);
      return this.getAllowedUploadHeaders(header).includes(uploadedHeader);
    })
      ? { isValid: true } 
      : { isValid: false };
  }

  private getAllowedUploadHeaders(header: string): string[] {
    return Array.from(new Set([
      this.normalizeUploadHeader(header),
      this.normalizeUploadHeader(this.translateWithFallback(header))
    ].filter(Boolean)));
  }

  private normalizeUploadHeader(header: any): string {
    return (header ?? '').toString().trim().replace(/\s+/g, ' ').toLowerCase();
  }

  private markHazardMeasureUploadSuccess(): void {
    this.isButtonEnable = true;
    this.eventProvider.BroadcastEvent(ObservationEvents.FILE_UPLOAD_SUCCESS, 'uploadDone');
    this.toastService.presentToast(this.translate.instant('file_uploaded_successfully'), 4000, AppConstants.SUCCESS_SNACKBAR, 'top');
  }

  private isFileArchiveSuccess(response: any): boolean {
    const statusReason = (response?.statusReason ?? response?.StatusReason ?? '').toString().trim().toLowerCase();
    return statusReason === 'file saved successfully' || statusReason === 'file updated successfully';
  }

  private logHazardMeasureArchiveWarning(error: any): void {
    console.warn('Hazard/measure data was saved, but upload file archive did not complete.', error);
  }

  uploadValid(event: any, type?: string) {
    this.type = type;
    const files = event.target.files;
    if (!this.validateFiles(files[0].name)) {
      this.toastService.presentToast(this.translate.instant('selected_file_format_not_supported'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
      return false;
    }
    else {
      this.uploadStandardDocument(event);
      this.isButtonEnable = true;
    }
  }

  uploadStandardDocument(event: any) {
    // this.uploadValid(event);
    console.log('uploadStandardDocument', this.type);
    if (this.type == 'Standard Documents') {
      const self = this;
      const file = event.target.files[0];
      const fileName = event.target.files[0].name;
      const fileSize = event.target.files[0].size;
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onload = async () => {
        const UploadImageFolderPath = standardsDocuments;
        await this.checkFolderExists(UploadImageFolderPath);
        const extFileName = fileName.split('.').slice(0, -1).join('.');
        const finalFileName = extFileName + '_' + Math.floor((Math.random() * 10987867960) + 1) + '.pdf';
        await this.UploadFileToSharePoint(UploadImageFolderPath, finalFileName, file, fileSize, this.type);
      };
      reader.onerror = (error) => {
      };
    }
    else {
      const self = this;
      const file = event.target.files[0];
      const fileName = event.target.files[0].name;
      const fileSize = event.target.files[0].size;
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onload = async () => {
        const UploadImageFolderPath = legislationsDocuments;
        await this.checkFolderExists(UploadImageFolderPath);
        const extFileName = fileName.split('.').slice(0, -1).join('.');
        const finalFileName = extFileName + '_' + Math.floor((Math.random() * 10987867960) + 1) + '.pdf';
        await this.UploadFileToSharePoint(UploadImageFolderPath, finalFileName, file, fileSize, this.type);
      };
      reader.onerror = (error) => {
      };
    }

  }

  validateFiles(name: String) {
    const ext = name.substring(name.lastIndexOf('.') + 1);
    if (ext == 'pdf') {
      return true;
    }
    else {
      return false;
    }
  }


  uploadValidDoc(event: any) {
    const files = event.target.files;
    if (!this.validateFilesDoc(files[0].name)) {
      // this.sharedValue.errorShowToast('', this.translate.instant('selected_file_format_not_supported'))
      return false;
    }
    else {
      // this.uploadtemplateDocument(event);
      // this.isButtonEnable = true;
    }
  }

  uploadtemplateDocument(event: any) {
    // this.uploadValid(event);
    if (this.type == 'Risk Assessment Report Template Library') {
      const self = this;
      const file = event.target.files[0];
      const fileName = event.target.files[0].name;
      const fileSize = event.target.files[0].size;
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onload = async () => {
        const UploadImageFolderPath = riskAssessmentReport;
        await this.checkFolderExists(UploadImageFolderPath);
        const extFileName = fileName.split('.').slice(0, -1).join('.');
        const finalFileName = extFileName + '_' + Math.floor((Math.random() * 10987867960) + 1) + '.docx';
        await this.UploadFileToSharePoint(UploadImageFolderPath, finalFileName, file, fileSize, this.type);
      };
      reader.onerror = (error) => {
      };
    }
    else {
      const self = this;
      const file = event.target.files[0];
      const fileName = event.target.files[0].name;
      const fileSize = event.target.files[0].size;
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onload = async () => {
        const UploadImageFolderPath = quoteTemplateLibrary;
        await this.checkFolderExists(UploadImageFolderPath);
        const extFileName = fileName.split('.').slice(0, -1).join('.');
        const finalFileName = extFileName + '_' + Math.floor((Math.random() * 10987867960) + 1) + '.docx';
        await this.UploadFileToSharePoint(UploadImageFolderPath, finalFileName, file, fileSize, this.type);
      };
      reader.onerror = (error) => {
      };
    }

  }

  validateFilesDoc(name: String) {
    const ext = name.substring(name.lastIndexOf('.') + 1);
    if (ext !== 'docx') {
      this.toastService.presentToast(this.translate.instant('selected_file_format_not_supported'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
    }
    else {
      this.isButtonEnable = true;
      this.uploadtemplateDocument(event);
      return false;
    }
  }

  async uploadRmap() {
    // const loader = await this.presentLoading('Please wait...');
    const payload = {
      legislations: this.uploadFileList[0],
      roadMap: this.roadMapData
    };
    this.backendService.uploadRoadMapData(payload).subscribe(
      async (response: any) => {
        if (response.value.statusReason == 'Failed to save data' || response.value.statusReason== 'Data saved with some duplicates skipped') {
          this.eventProvider.BroadcastEvent(ObservationEvents.ERROR_OCCURRED, 'roadmapUploadError');
          this.toastService.presentToast(this.translate.instant('roadmap_name_already_exists'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
          this.modalController.dismiss({ RoadFileUpload: false });
        }
        else {
          this.eventProvider.BroadcastEvent(ObservationEvents.FILE_UPLOAD_SUCCESS, 'uploadDone');
          this.toastService.presentToast(this.translate.instant('file_uploaded_successfully'), 4000, AppConstants.SUCCESS_SNACKBAR, 'top');
          this.modalController.dismiss({ RoadFileUpload: true });
        }
      },
      (err) => {
        this.eventProvider.BroadcastEvent(ObservationEvents.ERROR_OCCURRED, 'roadmapUploadError');
        this.graphService.deleteItem(this.uploadFileList[0].driveId, this.uploadFileList[0].itemId).subscribe(res => {
        });
      }
    );
  }

  uploadMacLibrary(fileName, file, fileSize) {
    this.backendService.uploadMasterData(this.master).subscribe(
      async (response: any) => {
        if (response.value == 'Failed to save data') {
          this.toastService.presentToast(this.translate.instant('failed_to_save_data'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
          this.isButtonEnable = false;
        }
        else {
          // this.sharedValue.showToast('', 'Data is saved ');
          this.isButtonEnable = true;
          const UploadImageFolderPath = machineLibrary;
          const extFileName = fileName.split('.').slice(0, -1).join('.');
          const finalFileName = extFileName + '_' + Math.floor((Math.random() * 10987867960) + 1) + '.xls';
          await this.checkFolderExists(UploadImageFolderPath);
          await this.UploadFileToSharePoint(UploadImageFolderPath, finalFileName, file, fileSize, this.type);
        }
      }, err => {
        this.toastService.presentToast(this.translate.instant('no_results_found'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
      }
    );
  }

  uploadControlMeaLibrary(fileName, file, fileSize) {
    this.type = HazardMeasureConstants.MEASURES;
    this.backendService.uploadControlMeasure(this.master).subscribe(
      async (response: any) => {
        if (isHazardMeasureSaveFailed(response)) {
          const translatedMessage = this.backendService.translateCounterMeasureMessage(
            response,
            (key, params) => this.translate.get(key, params)
          );
          if (translatedMessage) {
            translatedMessage.subscribe(message => this.toastService.presentToast(
              message,
              4000,
              AppConstants.ERROR_SNACKBAR,
              'top'
            ));
          } else {
            this.toastService.presentToast(
              this.translate.instant('failed_to_save_data'),
              4000,
              AppConstants.ERROR_SNACKBAR,
              'top'
            );
          }
          this.isButtonEnable = false;
          setTimeout(() => {
            this.eventProvider.BroadcastEvent(ObservationEvents.ERROR_OCCURRED, { toastShown: true });
          }, 3000);
        }
        else {
          this.markHazardMeasureUploadSuccess();
          const UploadImageFolderPath = controlMeasures;
          const extFileName = fileName.split('.').slice(0, -1).join('.');
          const finalFileName = extFileName + '_' + Math.floor((Math.random() * 10987867960) + 1) + '.xls';
          await this.checkFolderExists(UploadImageFolderPath);
          await this.UploadFileToSharePoint(UploadImageFolderPath, finalFileName, file, fileSize, this.type);
        }
      }, err => {
        if (err.status === 401) {
          return;
        }
        const translatedMessage = this.backendService.translateCounterMeasureMessage(
          err,
          (key, params) => this.translate.get(key, params)
        );
        if (translatedMessage) {
          translatedMessage.subscribe(message => this.toastService.presentToast(
            message,
            4000,
            AppConstants.ERROR_SNACKBAR,
            'top'
          ));
        } else {
          this.toastService.presentToast(
            this.translate.instant('no_results_found'),
            4000,
            AppConstants.ERROR_SNACKBAR,
            'top'
          );
        }
        setTimeout(() => {
          this.eventProvider.BroadcastEvent(ObservationEvents.ERROR_OCCURRED, { toastShown: true });
        }, 3000);
      }
    );
  }

  UploadInitialHazardLibrary(fileName, file, fileSize) {
    this.type = 'Initial Hazards';
    this.backendService.uploadIntialHazard(this.master).subscribe(
      async (response: any) => {
        if (isHazardMeasureSaveFailed(response)) {
          const message = response?.value || response?.message || response?.statusReason || this.translate.instant('failed_to_save_data');
          this.toastService.presentToast(message, 4000, AppConstants.ERROR_SNACKBAR, 'top');
          this.isButtonEnable = false;
          setTimeout(() => {
            this.eventProvider.BroadcastEvent(ObservationEvents.ERROR_OCCURRED, { toastShown: true });
          }, 3000);
        }
        else {
          this.markHazardMeasureUploadSuccess();
          //Upload file to share Point
          const UploadImageFolderPath = initialHazards;
          const extFileName = fileName.split('.').slice(0, -1).join('.');
          const finalFileName = extFileName + '_' + Math.floor((Math.random() * 10987867960) + 1) + '.xls';
          await this.checkFolderExists(UploadImageFolderPath);
          await this.UploadFileToSharePoint(UploadImageFolderPath, finalFileName, file, fileSize, this.type);
        }
      }, err => {
        if (err.status === 401) {
          return;
        }
        const message = err.error?.value || err.error?.message || this.translate.instant('no_results_found');
        this.toastService.presentToast(message, 4000, AppConstants.ERROR_SNACKBAR, 'top');
        setTimeout(() => {
          this.eventProvider.BroadcastEvent(ObservationEvents.ERROR_OCCURRED, { toastShown: true });
        }, 3000);
      }
    );
  }

  close() {
    const _self = this;
    _self.modalController.dismiss({
      dismissed: true,
    });
  }

  dismissUploadModal() {
    const _self = this;
    _self.modalController.dismiss({
      dismissed: true,
      fileName: this.uploadFileName,
      uploadDocument: true,
      title: this.type,
    });
    this.toastService.presentToast(this.translate.instant('file_uploaded_successfully'), 4000, AppConstants.SUCCESS_SNACKBAR, 'top');
  }

  dismissRoadMapModal() {
    const _self = this;
    if (isNotEmptyArray(this.roadMapData)) { this.uploadRmap(); }
    // _self.modalController.dismiss({
    //   dismissed: true,
    //   RoadFileUpload: true
    // });
    // this.sharedValue.showToast('', 'File Uploaded successfully');
  }

  dismissInitialHazard() {
    const _self = this;
    _self.modalController.dismiss({
      dismissed: true,
      intialUpload: true
    });
    this.toastService.presentToast(this.translate.instant('file_uploaded_successfully'), 4000, AppConstants.SUCCESS_SNACKBAR, 'top');
  }

  dismissMeasure() {
    const _self = this;
    _self.modalController.dismiss({
      dismissed: true,
      controlMeasure: true
    });
    this.toastService.presentToast(this.translate.instant('file_uploaded_successfully'), 4000, AppConstants.SUCCESS_SNACKBAR, 'top');
  }

  getRoadMapLibraryData() {
    if (isNotEmptyArray(this.libraryManagementUserInfo)) { this.libraryManagementUserInfo = []; }
    const _self = this;
    const payload = 'RoadMapLibrary';
    _self.backendService.getRoadMapDetails(payload).subscribe(res => {
      _self.roadMapUploadData = res;
      this.roadMapUploadData.forEach((element) => {
        this.libraryManagementUserInfo.push({
          machineId: element.id,
          machineTitle: element.name,
          machineType: element.type,
          machineManufacture: '',
          driveId: element.driveId,
          itemId: element.itemId
        });
      });
    }, err => {
      this.toastService.presentToast(this.translate.instant('no_results_found'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
    });
  }
}
